import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export default function Reset() {
  const [params] = useSearchParams();
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/reset-password", { token: params.get("token"), new_password: pwd }); toast.success("Contraseña actualizada. Inicia sesión."); navigate("/login"); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-md neon-card p-8 space-y-4 fade-up" data-testid="reset-form">
        <h1 className="font-display text-2xl font-bold">Nueva contraseña</h1>
        <div><Label>Contraseña nueva (mín. 6)</Label><Input data-testid="reset-password-input" type="password" className="h-12 mt-1" value={pwd} onChange={(e) => setPwd(e.target.value)} minLength={6} required /></div>
        <Button type="submit" disabled={busy} data-testid="reset-submit-button" className="w-full tap bg-primary text-primary-foreground hover:bg-cyan-400">{busy ? <Loader2 className="animate-spin" /> : "Guardar"}</Button>
      </form>
    </div>
  );
}
